'use client';

import { useEffect, useState } from 'react';

import { ultrasoundclinic } from '@/data/clinics/ultrasound-clinic';
import { BookingWidgetClient } from '@/features/booking/components/BookingWidgetClient';
import { useBookingFlowStore } from '@/features/booking/store/useBookingFlowStore';
import { mapDoctorToBookingDoctor } from '@/features/booking/utils/mapDoctorToBookingDoctor';
import { scrollToElement } from '@/utils';

const BOOKING_WIDGET_ID = 'booking-calendar-widget';
const BOOKING_WIDGET_HREF = `#${BOOKING_WIDGET_ID}`;

const SCAN_FINDER_ID = 'scan-finder';
const SCAN_FINDER_HREF = `#${SCAN_FINDER_ID}`;

export default function UltrasoundBookingScrollFix() {
  const [bookingWidgetOpen, setBookingWidgetOpen] = useState(false);

  const setSelectedDoctor = useBookingFlowStore((s) => s.setSelectedDoctor);
  const setCurrentStep = useBookingFlowStore((s) => s.setCurrentStep);
  const setShowModal = useBookingFlowStore((s) => s.setShowModal);
  const showModal = useBookingFlowStore((s) => s.showModal);

  useEffect(() => {
    if (!showModal && bookingWidgetOpen) {
      setBookingWidgetOpen(false);
    }
  }, [showModal, bookingWidgetOpen]);

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null;

      const bookingAnchor = target?.closest<HTMLAnchorElement>(
        `a[href="${BOOKING_WIDGET_HREF}"]`,
      );
      if (bookingAnchor) {
        event.preventDefault();
        event.stopPropagation();

        setSelectedDoctor(mapDoctorToBookingDoctor(ultrasoundclinic));
        setCurrentStep(1);
        setShowModal(true);
        setBookingWidgetOpen(true);
        return;
      }

      const scanFinderAnchor = target?.closest<HTMLAnchorElement>(
        `a[href="${SCAN_FINDER_HREF}"]`,
      );

      if (scanFinderAnchor) {
        event.preventDefault();
        event.stopPropagation();

        scrollToElement(SCAN_FINDER_ID);
      }
    };

    document.addEventListener('click', handleClick, { capture: true });
    return () =>
      document.removeEventListener('click', handleClick, { capture: true });
  }, [setSelectedDoctor, setCurrentStep, setShowModal]);

  return bookingWidgetOpen ? <BookingWidgetClient /> : null;
}
